import { Component, ElementRef, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ElementRegistryService } from "@shared/services/element-registry.service";

const APP_PREFIX = 'mnc'

@Component({
    selector: 'app-micro-app',
    template: '',
    standalone: false
})
export class MicroAppComponent implements OnInit {

  private element: HTMLElement;

  constructor(
    private elementRegistry: ElementRegistryService,
    private router: Router,
    element: ElementRef
  ) {
    this.element = element.nativeElement as HTMLElement;
  }

  ngOnInit(): void {
    // Get the name of the micro application.
    const appName = this.getAppName();

    if (appName) {
      this.elementRegistry.loadAllAppNames().then(appNames => {
        if (appNames.includes(appName)) {
          // load the micro application.
          this.elementRegistry.prepare(appName)
            // create the micro application host element.
            .then(() => this.element.innerHTML = `<${appName}></${appName}>`)
            // redirect back home if application is not found.
            .catch(() => this.router.navigateByUrl('/home'));
        } else {
          this.router.navigateByUrl('/home')
        }
      });
    } else {
      this.router.navigateByUrl('/home')
    }
  }

  private getAppName(): string {
    const parts = location.pathname.split('/');

    return parts.length > 1
      ? `${APP_PREFIX}-${parts[1]}`.toLowerCase()
      : '';
  }
}
